import * as Sentry from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addErrorEventOnSentry = (e: any) => {
  Sentry.captureException(e);
  console.error(e);
};
